import ClienteConsultForm from '@/features/client/components/consulta-cliente'

export function CadastrarClientePageCnpj() {
  return <ClienteConsultForm />
}
